import { render, staticRenderFns } from "./BlogTwo.vue?vue&type=template&id=d8b3a0c8&"
import script from "./BlogTwo.vue?vue&type=script&lang=js&"
export * from "./BlogTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports